import type { FC, ReactNode } from 'react';
import { useLayoutEffect, useRef, useState } from 'react';
import clsx from 'clsx';

import { useDeviceWidth } from 'hooks/useDeviceWidth';

import styles from './styles.module.scss';

export interface IStyledListItemProps {
    content: ReactNode;
    /** Маркер элемента списка */
    marker?: ReactNode;
}

const StyledListItem: FC<IStyledListItemProps> = ({ content, marker }) => {
    const isDecimalStyle = typeof marker === 'number';
    const contentWrapperRef = useRef<HTMLDivElement>(null);
    const markerRef = useRef<HTMLDivElement>(null);
    const [align, setAlign] = useState<'top' | 'middle'>('top');
    const { isDesktop } = useDeviceWidth();

    // особенность дизайна
    // если высота контента больше размера маркера - выравнивание должно быть по верхнему краю
    // иначе - по середине
    useLayoutEffect(() => {
        const markerHeight = markerRef.current?.offsetHeight ?? 0;
        const contentHeight = contentWrapperRef.current?.offsetHeight ?? 0;

        if (contentHeight <= markerHeight && isDesktop) setAlign('middle');
    }, [isDesktop, content, marker]);

    return (
        <li
            className={clsx(styles.wrapper, {
                [styles.decimal]: isDecimalStyle,
                [styles.wrapperAlignMiddle]: align === 'middle',
            })}
        >
            <div className={styles.mark} ref={markerRef}>
                {marker}
            </div>
            <div className={styles.content} ref={contentWrapperRef}>
                {content}
            </div>
        </li>
    );
};

export default StyledListItem;
